// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B-It","index":"styles_index__37ly2"};